import module from '../module';
import Constants from '../../../utils/CommonConstants';

module.directive('cartonomyCartGroups', [ '$rootScope',
    function ($rootScope) {
        return {
            template: require('../views/cartGroupsDirective.pug'),
            link: function (scope, element, attribute) {

              scope.overlayOpened = false;

                scope.openItem = (item) => {
                    if (item.externalProductId) {
                        $rootScope.$broadcast(Constants.Events.EXTERNAL_PRODUCT_DETAIL_REQUESTED, item.productUrl);
                    }
                };

                scope.isParticipantOwner = (participant) => {
                    return participant.status === Constants.CartDetails.Participant.Status.OWNER;
                };

                scope.isGneralMillsPOC = (item) =>{
                    // Hide price, checkout button, budget for: Pillsbury, Bettycrocker, Tablespoon// retailerShop
                    // CW-2661- hide :checkout, budget
                    return Constants.GENERAL_MILLS_POC.some((poc) => {return item.productUrl && item.productUrl.indexOf(poc) > -1}) && item.price == 0;
                }

              scope.canPayForParticipant = (group) => {
                return scope.isOwner && scope.cart.cartStatus === 'CHECKING_OUT' && group.participant.paymentStatus === 0 && !group.myTab;
              }

                scope.getItemOptions = (item) => {
                    if (!item.itemOption)
                        return '';

                    item.itemOption = item.itemOption.replace(/=/g, ': ');
                    let options = item.itemOption.split('||').filter(_ => _[0] !== '_');
                    return options;
                };

                scope.canShowGroupOwner = () => scope.cart.cartStatus === 'CHECKING_OUT' || scope.cart.cartStatus === 'OWNER_CHECKING_OUT';
                scope.canShowPaidStatus = () => scope.cart.cartStatus === 'CHECKING_OUT' || scope.cart.cartStatus === 'OWNER_CHECKING_OUT';
            }
        };
    } ]);



// WEBPACK FOOTER //
// ./src/modules/cart/directives/CartGroupsDirective.js